<template>
  <div class="page_ vasco_page_">
    <div class="top_ clearfix_">
      <div class="f_l_ img_wrap_">
        <img :src="productInfo.productImg" />
      </div>
      <div class="f_r_ img-content">
        <h1>{{ productInfo.productName }}</h1>
        <h5 class="mrg_t22_">{{ productInfo.ageRange }}</h5>
        <div class="mrg_t16_ plan_">
          {{ $t('addPolicy.h') }}{{ $t('unit.b') }}
          <a-select v-model="selectedPlanCode" @change="handlePlanSelect" class="baozSelect">
            <a-select-option v-for="item in planOptions" :key="item.code" :value="item.code">{{ item.name }}</a-select-option>
          </a-select>
        </div>

        <div class="group_ group_2 changeStyle_" v-if="productCode == 'BOCI19'">
          <span class="label_ label_1">
            <h5>{{ $t('productDetail.b') }}</h5>
          </span>
          <a-radio-group class="flex_1 width_" :style="{ height: daysHeight }" :options="calDaysOptions" v-model="selectedDay" @change="onDaysChange" />
          <div class="daysBtn" v-if="isShowDaysBtn && calDaysOptions.length > 5" @click="isShowDays">更多选择</div>
          <div
            class="daysBtn daysBtn_1"
            v-else-if="calDaysOptions.length > 5"
            @click="
              () => {
                isShowDaysBtn = true;
                daysHeight = '42px';
              }
            "
          >
            收起
          </div>
        </div>
        <div v-else>
          <h5 class="mrg_t22_">{{ $t('productDetail.b') }}</h5>
          <div class="option_list_ mrg_t16_">
            <label :key="index" v-for="(item, index) in planDays" @click="calcPremium(item.split('-')[0])" :class="{ active_: offsetDays == item.split('-')[0] }" class="item_">{{ item }}{{ $t('unit.a') }}</label>
            <label @click="calcPremium('year')" :class="{ active_: offsetDays == 'year' }" class="item_">{{ $t('labels.d') }}</label>
          </div>
        </div>
        <div class="mrg_t22_" v-if="productCode != 'BOCI19'">
          <a-range-picker 
            :open="openDateSelect"
            :disabledDate="disabledDate"
            v-model="rangeDate"
            @change="rangePicker"
            @calendarChange="calendarChange"
            @openChange="openDateSelect = !openDateSelect"
            :placeholder="[$t('input.c'), $t('input.d')]"
          > </a-range-picker>
          <span class="time_desc_">{{ $t('productDetail.a') }}</span>
        </div>
        <div class="clearfix_ bottom_wrap_ mrg_t22_ midome">
          <h5 class="f_l_">
            {{ $t('buttons.b') }}
            <label v-if="sumPremium">
              <span class="num_">{{ sumPremium }}</span
              >元
            </label>
          </h5>
          <!--  v-if="$route.query.p != 'BOCI19'" -->
          <div>
            <a-button @click="showVisible" v-if="productCode != 'BOCI19'" class="floright btn_default_ modio-btn" type="primary">
              {{ $t('buttons.e') || '立即投保' }}
            </a-button>
            <a-button v-else style="margin-left: 10px" @click="handleToLocation" class="floright btn_default_ modio-btn" type="primary"> {{ $t('buttons.e') || '立即投保' }}</a-button>
          </div>
        </div>
      </div>
    </div>
    <a-tabs :defaultActiveKey="0">
      <a-tab-pane class="pane_" tab="信息披露">
        <div class="content_ bgColor">
          <div class="flex item">
            <p class="name">承保公司：</p>
            <p class="val">{{ piluInfo.underCompanyName }}</p>
          </div>
          <div class="flex item">
            <p class="name">保司名称：</p>
            <p class="val">{{ piluInfo.companyName }}</p>
          </div>
          <div class="flex item">
            <p class="name">合作期限：</p>
            <p class="val">
              {{ piluInfo.cooperationStartDate }} 至
              {{ piluInfo.cooperationEndDate }}
            </p>
          </div>
          <div class="flex item">
            <p class="name">合作范围：</p>
            <p class="val">{{ piluInfo.cooperationScope }}</p>
          </div>
          <div class="flex item detail">
            <p class="name">详细信息：</p>
            <p class="val">{{ piluInfo.insuranceNoticeInfo }}</p>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
    <div class="tabs_wrap_">
      <label @click="activeTab = 1" :class="{ active_: activeTab == 1 }">{{ $t('h.a') }}</label>
      <label @click="activeTab = 2" :class="{ active_: activeTab == 2 }">{{ $t('h.b') }}</label>
      <label @click="activeTab = 3" :class="{ active_: activeTab == 3 }">{{ $t('h.c') }}</label>
      <label @click="activeTab = 4" :class="{ active_: activeTab == 4 }">{{ $t('h.d') }}</label>
    </div>
    <div class="table_wrap_">
      <template v-if="activeTab == 1">
        <a-table :pagination="false" :columns="columns" :dataSource="tableData"> </a-table>
        <a-table class="mrg_t22_" :pagination="false" :columns="premiumColumns" :dataSource="premiumRules"></a-table>
        <a-table v-if="productCode == 'BOCI19'" class="mrg_t22_" :pagination="false" :columns="notileColumns" :dataSource="notileRules"></a-table>
      </template>
      <div class="tbxz_" v-else-if="activeTab == 2">
        <div v-if="productCode == 'BOCI19'">
          <div :style="`overflow: hidden;${expandContent ? 'height: auto;' : 'height: 600px;'}`">
            <div class="content_" v-html="product && product.tabDtos && product.tabDtos[1].tabContent"></div>
          </div>
          <div v-if="(product && product.tabDtos && product.tabDtos[1].tabContent.length > 300) || (product && product.tabDtos && product.tabDtos[1].tabContent.indexOf('img') > -1)" class="spread_">
            <button class="inner-btn" :class="expandContent ? 'hide-btn' : ''" @click="handleExpandDetail">
              {{ expandContent ? '收起全部' : '展开全部' }}
              <img src="@/assets/image/down.png" class="icon_" />
            </button>
          </div>
          <div class="bottom_"></div>
        </div>
        <div v-else>
          <tbxz :lang="currentLang" />
          <tbsm :lang="currentLang" />
        </div>
      </div>
      <div v-else-if="activeTab == 3" class="tbxz_">
        <div v-if="productCode == 'BOCI19'">
          <div :style="`overflow: hidden;${expandContent ? 'height: auto;' : 'height: 600px;'}`">
            <div class="content_" v-html="product && product.tabDtos && product.tabDtos[2].tabContent"></div>
          </div>
          <div v-if="(product && product.tabDtos && product.tabDtos[2].tabContent.length > 300) || (product && product.tabDtos && product.tabDtos[2].tabContent.indexOf('img') > -1)" @click="handleExpandDetail" class="spread_">
            {{ expandContent ? '收起全部' : '展开全部' }}
            <a-icon type="right" class="icon_" />
          </div>
          <div class="bottom_"></div>
        </div>
        <div v-else>
          <div v-if="productCode == 'BOCI18'">
            <h4 v-for="item_f in fileList" :key="item_f.insuranceName">
              《{{ item_f.insuranceName }}》<a class="download_" :download="item_f.insuranceName" :href="item_f.insuranceLink">{{ $t('labels.k') }}</a>
            </h4>
          </div>
          <div v-else>
            <h4>
              《{{ productInfo.insuranceName }}》<a class="download_" :download="productInfo.insuranceDownloadName" :href="productInfo.insuranceFile">{{ $t('labels.k') }}</a>
            </h4>
          </div>
        </div>
      </div>
      <div v-else-if="activeTab == 4" class="lpzy_">
        <div v-if="productCode == 'BOCI19'">
          <div :style="`overflow: hidden;${expandContent ? 'height: auto;' : 'height: 600px;'}`">
            <div class="content_" v-html="product && product.tabDtos && product.tabDtos[3].tabContent"></div>
          </div>
          <div v-if="(product && product.tabDtos && product.tabDtos[3].tabContent.length > 300) || (product && product.tabDtos && product.tabDtos[3].tabContent.indexOf('img') > -1)" class="spread_">
            <button class="inner-btn" :class="expandContent ? 'hide-btn' : ''" @click="handleExpandDetail">
              {{ expandContent ? '收起全部' : '展开全部' }}
              <img src="@/assets/image/down.png" class="icon_" />
            </button>
          </div>
          <div class="bottom_"></div>
        </div>
        <div v-else>
          <h4>
            《{{ productInfo.claimGuideName }}》<a class="download_" :download="productInfo.claimGuideDownloadName" :href="productInfo.claimGuideFile">{{ $t('labels.k') }}</a>
          </h4>
          <h4 class="mrg_t27_">
            {{ $t('labels.g') }}<a class="download_" download="索赔申请书下载.pdf" :href="productInfo.claimFormFile">{{ $t('labels.k') }}</a>
          </h4>
          <div v-if="productInfo.lpShow" class="mrg_t27_">
            {{ $t('labels.e') }} <br />
            {{ $t('labels.f') }} <br />
            {{ $t('labels.i') }}<span class="highlight_">400-920-3123</span><br />
            {{ $t('labels.j') }}<span class="highlight_">400-920-3123</span>
          </div>
        </div>
      </div>
    </div>

    <a-modal :title="$t('wordArray[2]') || '温馨提示：'" top="5%" :visible="visible" :footer="null" class="modal_center_" @cancel="handleCancel" dialogClass="myDal_">
      <p>
        {{ $t('confirm[0]') || '1. 根据银保监会相关规定，您即将进入投保流程页面，后续的操作将被记录。' }}
      </p>
      <p>
        {{ $t('confirm[1]') || '2. 为保护您的权益，投保前请您确认已了解产品详情，并自行阅读下列文件，以全包您已经理解产品的相关细节。' }}
      </p>
      <p class="readed_">
        {{ $t('confirm[2]') || '请逐一点开并阅读下列重要文件：' }}
      </p>
      <p class="p_" :class="[readArray.indexOf(1) > -1 ? 'readed_' : '']" @click.stop="toClause(1, $t('confirm[3]') || '保险条款')">
        {{ $t('confirm[3]') || '保险条款' }}
      </p>
      <p class="p_" :class="[readArray.indexOf(2) > -1 ? 'readed_' : '']" @click.stop="toClause(2, $t('confirm[4]') || '免责声明')">
        {{ $t('confirm[4]') || '免责声明' }}
      </p>
      <p class="p_" :class="[readArray.indexOf(3) > -1 ? 'readed_' : '']" @click.stop="toClause(3, $t('confirm[5]') || '投保须知')">
        {{ $t('confirm[5]') || '投保须知' }}
      </p>
      <p class="p_" :class="[readArray.indexOf(4) > -1 ? 'readed_' : '']" @click.stop="toClause(4, $t('confirm[6]') || '客户告知书')">
        {{ $t('confirm[6]') || '客户告知书' }}
      </p>
      <div class="btn_">
        <a-button class="mrg_r22_" @click.stop="handleCancel" type="primary">{{ $t('wordArray[1]') || '放弃' }}</a-button>
        <a-button @click="toAstpAddPolicy" :disabled="disabled" type="primary">{{ $t('wordArray[0]') || '已确认' }}</a-button>
      </div>
    </a-modal>

    <a-modal :width="800" :title="clauseTitle" @cancel="handleCalcelVlause" :visible="clauseVisible" class="myClause_">
      <div v-if="clauseType == 3">
        <tbxz :lang="currentLang" />
        <tbsm :lang="currentLang" />
      </div>
      <div v-else>
        <pdfView :visible="clauseVisible" :fileUrl="FILESURL" />
      </div>

      <template slot="footer">
        <a-button
          class="mrg_r22_"
          @click="
            clauseVisible = false;
            visible = true;
          "
          type="primary"
          >取消阅读</a-button
        >
        <a-button class="mrg_r22_" @click="pushToRead" :disabled="readDisabled" type="primary">{{ readDisabled ? $t('wordArray[3]') || '请上滑看完本内容再同意' : $t('wordArray[4]') || '我已阅读' }}{{ readDisabled ? '(' + second + 'S)' : '' }}</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import policyMixin from './mixins/policy';
import pdfView from './components/pdfView';
import moment from 'moment'
let self = '';
let componentPath = '';
export default {
  data() {
    self = this;
    let { p, productCode } = self.$route.query;
    componentPath = p == 'AS' ? '' : p ? '/' + p : '';
    return {
      FILESURL: '',
      piluInfo: {},
      planDays: [],
      planDay: '',
      calDaysOptions: [], //日期选项
      selectedDay: '',
      isShowDaysBtn: true, //更多选择的展示
      srcString: '',
      second: 3,
      clauseType: 1,
      expandContent: false,
      readDisabled: true,
      clauseVisible: false,
      clauseTitle: '',
      disabled: true,
      visible: false,
      readArray: [],
      product: {},
      activeTab: 1,
      sumPremium: '',
      offsetDays: 1,
      rangeDate: [],
      columns: [],
      premiumRules: [],
      notileRules: [],
      notileules: [],
      daysHeight: '42px',
      premiumColumns: [],
      notileColumns: [],
      tableData: [],
      productCode,
      fileList: [
        {
          insuranceName: this.$t('BOCIList[0]'),
          insuranceLink: '/axa/files/ZY/insurance1.pdf',
        },
        {
          insuranceName: this.$t('BOCIList[1]'),
          insuranceLink: '/axa/files/ZY/insurance2.pdf',
        },
        {
          insuranceName: this.$t('BOCIList[2]'),
          insuranceLink: '/axa/files/ZY/insurance3.pdf',
        },
        {
          insuranceName: this.$t('BOCIList[3]'),
          insuranceLink: '/axa/files/ZY/insurance4.pdf',
        },
        {
          insuranceName: this.$t('BOCIList[4]'),
          insuranceLink: '/axa/files/ZY/insurance5.pdf',
        },
        {
          insuranceName: this.$t('BOCIList[5]'),
          insuranceLink: '/axa/files/ZY/insurance6.pdf',
        },
      ],
      openDateSelect: false,
    };
  },
  components: {
    tbsm: () => {
      return import(`./components${componentPath}/tbsm.vue`);
    },
    tbxz: () => {
      return import(`./components${componentPath}/tbxz.vue`);
    },
    pdfView,
  },
  computed: {
    agreementRead() {
      //是否阅读告知书
      return this.$store.state.insureDoc.agreementRead;
    },
  },
  watch: {
    agreementRead: function (val) {
      if (val) {
        this.$router.push({
          name: 'astpAddPolicy',
          query: {
            ...this.$route.query,
          },
        });
      }
    },
  },
  mixins: [policyMixin],
  mounted() {
    const { productCode, u } = this.$route.query;
    this.productCode = productCode;
    if (productCode && productCode == 'BOCI19') {
      //不是太保雇主才调用
      this.getPolicyOptions(productCode);
      this.querproduct({
        userId: u,
        productCode: productCode,
      });
      this.$store.dispatch('getMaterial', { mdProductCode: productCode, webUserId: u, _this: this }); //获取客户告知书承包等投保文件
    }
    this.$api
      .queryPiluInfo(productCode || 'axatp002')
      .then(res => {
        if (res.data.returnCode == 0) {
          this.piluInfo = res.data.data || {};
        }
      })
      .catch(() => {});
  },
  methods: {
    handleExpandDetail() {
      this.expandContent = !this.expandContent;
      if (!this.expandContent) {
        location.hash = '';
        location.hash = 'tab_';
      }
    },
    querproduct(userParams) {
      this.$api.querproduct(userParams).then(res => {
        const content = res.data.content;
        this.insuranceInformation = content.policyInsure;
        this.product = content;
        const type = content.policyHolderType;
        this.type = type == 1 ? 'I' : type == 2 ? 'C' : 'I';
        this.isShowByType = this.type == 'I' ? true : false;
      });
    },
    handleCountPremium() {
      console.log('开始试算保费参数 -> ', this.selectedPlanCode, this.planDay, this.calAges);
      let periodType = '';
      let policyPeriod = '';
      if (!this.selectedPlanCode) {
        this.$message.info('请先选择保障计划！');
        return;
      }
      if (this.planDay) {
        const planDaysArr = this.planDay.split('_');
        periodType = planDaysArr[2];
        policyPeriod = `${planDaysArr[0]}_${planDaysArr[1]}`;
      } else {
        this.$message.info('请先选择出行天数！');
        return;
      }
      const premiumReqDtos = [
        {
          insuredAgePeriod: '60_d_80_y',
          count: 1,
          plan: this.selectedPlanCode,
          periodType,
          policyPeriod,
        },
      ];
      const params = {
        premiumReqDtos,
        productCode: this.productCode,
      };
      this.$api
        .calPremiumTrial(params)
        .then(res => res.data)
        .then(data => {
          this.sumPremium = data.content;
        });
    },
    //天数checkbox
    onDaysChange(e) {
      console.log('checked = ', e);
      this.planDay = e.target.value;
      this.handleCountPremium();
    },
    isShowDays() {
      //更多选择按钮的展示
      this.daysHeight = 'auto';
      this.isShowDaysBtn = false;
    },
    getPolicyOptions(productCode) {
      this.$api
        .getPolicyOptions({
          productCode,
        })
        .then(res => res.data)
        .then(data => {
          console.log('产品选项数据 -> ', data);
          const { tripDays } = data.content;
          const planDayOptions = [];
          const formatUnit = (val, day) => {
            return val === 'y' ? (day === 1 ? '周岁' : '年') : val === 'm' ? '个月' : '天';
          };
          let minPlanDay = 365;
          for (let i = 0; i < tripDays.length; i++) {
            let item = tripDays[i];
            const unit = formatUnit(item.dayType);
            let label = `${item.minimumDay}-${item.maximumDay}${unit}`;
            if (item.minimumDay == item.maximumDay) {
              label = `${item.maximumDay}${unit}`;
            }
            if (item.dayType == 'd' && minPlanDay > item.minimumDay) {
              minPlanDay = item.minimumDay;
            }
            planDayOptions.push({
              label,
              value: `${item.minimumDay}_${item.maximumDay}_${item.dayType}`,
              min: item.minimumDay,
              max: item.maximumDay,
              unit: item.dayType,
              unitFormat: unit,
            });
          }
          this.calDaysOptions = planDayOptions;
        });
    },
    setTime() {
      this.second = 3;
      let st = setInterval(() => {
        this.second--;
        console.log(this.second, '-->');
        if (this.second == 0) {
          this.readDisabled = false;
          this.second = 3;
          clearInterval(st);
        }
      }, 1000);
    },
    handleCalcelVlause() {
      this.clauseVisible = false;
    },
    handleCancel() {
      console.log('Clicked cancel button');
      this.visible = false;
    },
    pushToRead() {
      //我已阅读
      this.readDisabled = true; //重置上滑时间倒计时
      let type = this.clauseType;
      if (this.readArray.indexOf(type) == -1) {
        this.readArray.push(type);
      }
      this.visible = true;
      this.clauseVisible = false;
      if (this.readArray.length && this.readArray.length == 4) {
        this.disabled = false;
      }
    },
    toClause(type, txt) {
      //跳转条款
      let p = this.$route.query.p;
      this.clauseType = type;
      if (p == 'ZY') {
        switch (type) {
          case 1:
            this.FILESURL = `/pdf/web/viewer.html?file=${encodeURIComponent('/axa/files/ZY/Insurance.pdf')}&time=${new Date().getTime()}`; //中银的保险条款
            break;
          case 2:
            this.FILESURL = `/pdf/web/viewer.html?file=${encodeURIComponent('/axa/files/ZY/zrmc.pdf')}&time=${new Date().getTime()}`; //中银的免责声明
            break;
          case 4:
            this.FILESURL = `/pdf/web/viewer.html?file=${encodeURIComponent('/axa/files/ZY/khgzs.pdf')}&time=${new Date().getTime()}`; //中银的客户告知书
            break;
          default:
            break;
        }
      } else {
        switch (type) {
          case 1:
            this.FILESURL = `/pdf/web/viewer.html?file=${encodeURIComponent('/axa/files/bxtk.pdf')}&time=${new Date().getTime()}`; //安盛的保险条款
            break;
          case 2:
            this.FILESURL = `/pdf/web/viewer.html?file=${encodeURIComponent('/axa/files/安盛天平免责声明.pdf')}&time=${new Date().getTime()}`; //安盛的免责声明
            break;
          case 4:
            this.FILESURL = `/pdf/web/viewer.html?file=${encodeURIComponent('/axa/files/khgzs.pdf')}&time=${new Date().getTime()}`; //中银的客户告知书
            break;
          default:
            break;
        }
      }
      this.clauseTitle = txt;
      this.visible = false;
      this.clauseVisible = true;
      this.setTime();
    },

    handleToLocation() {
      this.$store.commit('setAgreement', true);
    },
    showVisible() {
      // if (this.skipModal) {
      //   this.toAstpAddPolicy();
      //   return
      // }
      this.visible = true;
    },
    toAstpAddPolicy() {
      this.$router.push({
        name: 'astpAddPolicy',
        query: {
          ...this.$route.query,
        },
      });
    },
    calendarChange(arr, arrstr) {
      console.log('calendarChange -> ', arr, arrstr)
      if ((arr[0] || arr[1]) && this.offsetDays == 'year') {
        this.rangePicker(arr)
        this.openDateSelect = false
      }
    },
    rangePicker(values) {
      const startDate = values[0].format('YYYY-MM-DD');
      // 选择全年保障
      if(this.offsetDays == 'year') {
        this.rangeDate = [values[0], moment(values[0]).add(1, 'years').subtract(1, 'days')]
        return
      }
      let offsetDay = values[1].diff(values[0], 'days') + 1;
      this._offsetDay = offsetDay;
      this.planOffsetDay = offsetDay;
      this._effectiveDate = startDate;
      this.calcPremium(offsetDay, true);
      console.log('计划时间范围选择 -> ', this._offsetDay, values);
    },
    calcPremium(days, notClear = false) {
      this._planValue = this._planValue || 1;
      if (days !== 'year' && this._planValue > 3) {
        this.selectedPlanCode = this.planOptions[0].code;
        this._planValue = 1;
      } else if (days == 'year' && this._planValue < 4) {
        this.selectedPlanCode = this.planOptions[3].code;
        this._planValue = 4;
      }
      // 重置日期选择的值
      if (!notClear) {
        this.rangeDate = [];
      }
      // 记录天数选中的状态
      this.offsetDays = days;
      // 计算保费
      this.sumPremium = this._calcPremium(this._planIndex || 1, days);
    },
  },
};
</script>
<style lang="scss">
.changeStyle_ {
  .ant-radio-group {
    .ant-radio-wrapper-checked {
      color: rgba(254, 143, 45, 1) !important;
      border: 1px solid #fe8f2d !important;
    }
  }
  .ant-radio-inner {
    display: none !important;
  }
  .ant-radio-wrapper {
    margin: 0px 20px 10px 10px;
    font-weight: 400;
    padding: 5px 10px;
    border: 1px solid rgba(229, 229, 229, 1);
  }
}
/* 移动端  */
@media all and (max-width: 750px) {
  .ant-modal {
    top: 0;
  }
}
/* PC端 */
@media all and (min-width: 750px) {
  .ant-modal {
    top: 100px !important;
  }
}
</style>
<style lang="scss" scoped>
/* 移动端  */
@media all and (max-width: 750px) {
  .modio-btn {
    margin-top: 10px;
  }
  .midome {
    display: flex;
    flex-direction: column;
  }
  .baozSelect {
    width: 100%;
  }
  .ant-select {
    width: 100%;
  }
  .page_ {
    .option_list_ {
      width: 100%;
      .item_ {
        margin-bottom: 12px;
      }
    }
    .table_wrap_ {
      background: #fff;
      padding: 15px;
      box-sizing: border-box;
      margin-bottom: 61px;
      // 投保须知
      .tbxz_ {
        p {
          color: #394553;
          white-space: pre-wrap;
        }
      }
      // 保险条款
      .bxtk_,
      .lpzy_ {
        h4 {
          font-size: 18px;
        }
        .download_ {
          font-size: 12px;
          color: #394553;
        }
        .highlight_ {
          color: #ff3e18;
          font-weight: bold;
        }
      }
      h4 {
        font-size: 15px;
        line-height: 17px;
        padding-left: 12px;
        border-left: 3px solid #ff3e18;
      }
    }
    .mrg_t22_ {
      margin-top: 22px;
      display: flex;
      flex-direction: column;
    }

    .mrg_t16_ {
      margin-top: 16px;
    }
    .mrg_t27_ {
      margin-top: 27px;
    }
    .top_ {
      padding: 20px;
      box-sizing: border-box;
      background: #fff;
      margin-top: 22px;
      .plan_ {
        font-size: 18px;
        font-weight: bold;
      }
      .bottom_wrap_ {
        label {
          font-size: 12px;
          font-weight: bold;
          color: #ff3e18;
        }
        .num_ {
          font-size: 26px;
          margin-right: 8px;
        }
      }
      .img_wrap_ {
        width: 100%;
        height: auto;
        overflow: hidden;
        margin-bottom: 10px;
        img {
          width: 100%;
          height: auto;
        }
      }
      .img-content {
        width: 100%;
        // padding: 0 20px;
        box-sizing: border-box;
      }
      .time_desc_ {
        font-size: 12px;
        margin-top: 10px;
      }
      h1 {
        font-size: 20px;
        line-height: 20px;
      }
      h5 {
        font-size: 18px;
        color: #394553;
      }
      .option_list_ {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .item_ {
          display: inline-block;
          width: 85px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          border: 1px solid #d2d2d2;
          color: #2a3542;
          font-size: 12px;
          box-shadow: 0px 7px 18px 3px rgba(229, 243, 234, 0.35);
          border-radius: 4px;
          cursor: pointer;
          &:last-child {
            margin-right: 0;
          }
          &.active_ {
            color: #fff;
            background: #ff3e18;
            border: 1px solid #ff3e18;
          }
        }
      }
    }
    .tabs_wrap_ {
      cursor: pointer;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 20px;
      box-sizing: border-box;
      label {
        display: inline-block;
        padding: 13px 26px;
        font-size: 13px;
        border-radius: 4px;
        text-align: center;
        border: 1px solid #d2d2d2;
        color: #2a3542;
        margin: 5px 0;
        background: #fff;
        cursor: pointer;

        &.active_ {
          color: #fff;
          background: rgba(255, 62, 24, 1);
          border: 1px solid #ff3e18;
        }
      }
    }
  }
  .btn_ {
    display: flex;
    justify-content: center;
  }
  .p_ {
    color: #1b7cf8;
    cursor: pointer;
  }

  .readed_ {
    color: #ff3e18;
  }
  .mrg_r22_ {
    margin-right: 22px;
    span {
      display: block;
    }
  }
  .pane_ {
    font-size: 12px;
    font-family: Microsoft YaHei UI;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);

    img {
      height: auto;
    }
  }
  .bgColor {
    background-color: rgb(252, 246, 238);
    padding: 20px;
    box-sizing: border-box;
    p {
      line-height: 20px;
    }
    .bold_ {
      font-weight: bold;
    }
  }
  .content_ img {
    height: auto;
  }
  .content_ {
    min-height: 85px;
  }
  .content_ img {
    height: auto;
  }
  .flex {
    display: flex;
    align-items: center;
    &.item {
      .name {
        min-width: 65px;
      }
    }
    &.detail {
      align-items: initial;
    }
  }
}

/* PC端 */
@media all and (min-width: 750px) {
  .floright {
    float: right;
  }
  .baozSelect {
    width: 500px;
  }
  .page_ {
    .option_list_ {
      width: 644px;
      .item_ {
        margin-bottom: 12px;
      }
    }
    .table_wrap_ {
      background: #fff;
      padding: 31px;
      margin-bottom: 61px;
      // 投保须知
      .tbxz_ {
        p {
          color: #394553;
          white-space: pre-wrap;
        }
      }
      // 保险条款
      .bxtk_,
      .lpzy_ {
        h4 {
          font-size: 18px;
        }
        .download_ {
          font-size: 12px;
          color: #394553;
        }
        .highlight_ {
          color: #ff3e18;
          font-weight: bold;
        }
      }
      h4 {
        font-size: 15px;
        line-height: 17px;
        padding-left: 12px;
        border-left: 3px solid #ff3e18;
      }
    }
    .mrg_t22_ {
      margin-top: 22px;
    }

    .mrg_t16_ {
      margin-top: 16px;
    }
    .mrg_t27_ {
      margin-top: 27px;
    }
    .top_ {
      padding: 23px 46px 23px 23px;
      background: #fff;
      margin-top: 22px;
      .plan_ {
        font-size: 18px;
        font-weight: bold;
      }
      .bottom_wrap_ {
        label {
          font-size: 12px;
          font-weight: bold;
          color: #ff3e18;
        }
        .num_ {
          font-size: 26px;
          margin-right: 8px;
        }
      }
      .img_wrap_ {
        width: 233px;
        height: 263px;
        overflow: hidden;
        img {
          width: 100%;
          height: auto;
        }
      }
      .time_desc_ {
        font-size: 12px;
        margin-left: 22px;
      }
      h1 {
        font-size: 20px;
        line-height: 20px;
      }
      h5 {
        font-size: 18px;
        color: #394553;
      }
      .option_list_ {
        .item_ {
          display: inline-block;
          width: 85px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          margin-right: 22px;
          border: 1px solid #d2d2d2;
          color: #2a3542;
          font-size: 12px;
          box-shadow: 0px 7px 18px 3px rgba(229, 243, 234, 0.35);
          border-radius: 4px;
          cursor: pointer;
          &:last-child {
            margin-right: 0;
          }
          &.active_ {
            color: #fff;
            background: #ff3e18;
            border: 1px solid #ff3e18;
          }
        }
      }
    }
    .tabs_wrap_ {
      cursor: pointer;
      margin: 23px 0 28px;
      label {
        display: inline-block;
        padding: 13px 26px;
        font-size: 13px;
        border-radius: 4px;
        text-align: center;
        border: 1px solid #d2d2d2;
        color: #2a3542;
        margin-right: 22px;
        background: #fff;
        cursor: pointer;

        &.active_ {
          color: #fff;
          background: rgba(255, 62, 24, 1);
          border: 1px solid #ff3e18;
        }
      }
    }
  }
  .btn_ {
    display: flex;
    justify-content: center;
  }
  .p_ {
    color: #1b7cf8;
    cursor: pointer;
  }

  .readed_ {
    color: #ff3e18;
  }
  .mrg_r22_ {
    margin-right: 22px;
  }
  .pane_ {
    font-size: 12px;
    font-family: Microsoft YaHei UI;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);

    img {
      height: auto;
    }
  }
  .bgColor {
    background-color: rgb(252, 246, 238);
    padding: 10px;
    p {
      line-height: 20px;
    }
    .bold_ {
      font-weight: bold;
    }
  }
  .content_ img {
    height: auto;
  }
  .content_ {
    min-height: 85px;
  }
  .content_ img {
    height: auto;
  }
  .flex {
    display: flex;
    align-items: center;
    &.item {
      .name {
        min-width: 65px;
      }
    }
    &.detail {
      align-items: initial;
    }
  }
}
.group_ {
  margin: 30px 0;
  display: flex;
  align-items: center;
  &.align_item_top_ {
    align-items: flex-start;
  }
  .flex_1 {
    // flex: 1;
  }
  .width_ {
    max-width: 460px;
    overflow: hidden;
  }
  .daysBtn {
    min-width: 106px;
    font-family: Microsoft YaHei UI;
    font-weight: 400;
    font-size: 10px;
    color: rgba(51, 51, 51, 1);
    border: 1px solid rgba(229, 229, 229, 1);
    padding: 8px 34px 8px 22px;
    margin-right: 10px;
    position: relative;
    text-decoration: none;
    cursor: pointer;
    &::after {
      position: absolute;
      top: 11px;
      right: 18px;
      display: block;
      content: '';
      width: 8px;
      height: 8px;
      border-bottom: 2px solid #666666;
      border-right: 2px solid #666666;
      transform: rotateZ(45deg);
    }
  }
  .daysBtn_1 {
    &::after {
      border-bottom: 0;
      border-right: 0;
      top: 15px;
      border-left: 2px solid #666666;
      border-top: 2px solid #666666;
    }
  }

  .label_ {
    margin-right: 10px;
    font-family: Microsoft YaHei UI;
    font-weight: 460;
    color: rgba(51, 51, 51, 1);
    display: inline-block;
    min-width: 70px;
    text-align: right;
  }
  .label_1 {
    margin-top: 6px;
  }
  .ant-radio-group {
    .ant-radio-wrapper-checked {
      color: rgba(254, 143, 45, 1);
      border: 1px solid #fe8f2d;
    }
  }
  .ant-radio-inner {
    display: none !important;
  }
  .ant-radio-wrapper {
    margin: 0px 20px 10px 10px;
    font-weight: 400;
    padding: 5px 10px;
    border: 1px solid rgba(229, 229, 229, 1);
  }
}
.group_2 {
  align-items: flex-start;
}
</style>